import * as React from "react";
import { useTranslation } from "react-i18next";

//MUI
import { Button, useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

//MUI Icons
import TranslateIcon from "@mui/icons-material/Translate";

//Custom Components
import HeaderMenuButton from "@/ui/Header/HeaderMenuButton";
import HeaderMenuItem from "@/ui/Header/HeaderMenuItem";

const LanguageSelector = ( props: {overrideBreakpoint?: boolean}) => {
  const { i18n } = useTranslation();

  
  const {overrideBreakpoint} = props

  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));

  return (
   
    i18n.language === "en" ?
      <Button
        variant="text"
        onClick={() => {
          i18n.changeLanguage("hr");
        }}
      >
        Hrvatski
      </Button> : 
      <Button
        variant="text"
        onClick={() => {
          i18n.changeLanguage("en");
        }}
      >
        English
      </Button>
  );
};

export default LanguageSelector;

